const ANALYTICS_URL = import.meta.env.VITE_ANALYTICS_URL
const ANALYTICS_TOKEN = import.meta.env.VITE_ANALYTICS_TOKEN
const STORAGE_KEY = 'openhasp_last_visit'

export function trackVisit() {
  if (!ANALYTICS_URL) return

  const today = new Date().toISOString().slice(0, 10) // YYYY-MM-DD
  if (localStorage.getItem(STORAGE_KEY) === today) return
  localStorage.setItem(STORAGE_KEY, today)

  const source = typeof window.__TAURI__ !== 'undefined' ? 'desktop' : 'web'
  const line = `visits,source=${source},version=${__APP_VERSION__} count=1i`

  const headers = { 'Content-Type': 'text/plain; charset=utf-8' }
  if (ANALYTICS_TOKEN) headers['Authorization'] = `Token ${ANALYTICS_TOKEN}`

  fetch(ANALYTICS_URL, { method: 'POST', headers, body: line, keepalive: true }).catch(() => {})
}
